import { Link } from "react-router-dom";

interface VideoCardProps {
  id: number;
  title: string;
  slug: string;
  category: string;
  thumbnail: string;
  duration: string;
  year: number;
  rating: number;
  views: number;
  tags: string[];
}

export default function VideoCard({
  id,
  title,
  slug,
  category,
  thumbnail,
  duration,
  year,
  rating,
  views,
  tags,
}: VideoCardProps) {
  const formatViews = (v: number) => {
    if (v >= 10000) return `${(v / 10000).toFixed(1)}万`;
    return v.toString();
  };

  return (
    <Link
      to={`/article/${id}`}
      className="group block cursor-pointer"
      data-product-shop
    >
      <div className="relative overflow-hidden rounded-lg aspect-video bg-background-200">
        <img
          src={thumbnail}
          alt={title}
          title={`${title} - 91国产视频在线观看`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
        />
        <div className="absolute top-2 right-2 bg-black/70 text-white text-xs px-1.5 py-0.5 rounded whitespace-nowrap">
          {duration}
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
          <div className="flex items-center gap-2">
            <i className="ri-play-circle-fill text-white text-2xl"></i>
            <span className="text-white text-sm font-medium">立即播放</span>
          </div>
        </div>
      </div>
      <div className="mt-2.5">
        <h3 className="text-sm font-semibold text-foreground-950 line-clamp-1 group-hover:text-primary-500 transition-colors">
          {title}
        </h3>
        <div className="flex items-center gap-2 mt-1.5">
          <span className="text-xs text-foreground-500">{year}</span>
          <span className="text-xs text-foreground-400">·</span>
          <span className="text-xs text-accent-500 font-medium flex items-center gap-0.5">
            <i className="ri-star-fill text-[10px]"></i>
            {rating}
          </span>
          <span className="text-xs text-foreground-400">·</span>
          <span className="text-xs text-foreground-500">{formatViews(views)}次播放</span>
        </div>
        <div className="flex flex-wrap gap-1 mt-1.5">
          {tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="text-[10px] px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-700 whitespace-nowrap"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}